(function () {
    'use strict';

    angular
        .module("skillsApp")
        .controller("AppMainController", AppMainController);

    function AppMainController(config) {
        var vm = this;

        vm.settings = config.settings;

        vm.showSkillsReport = vm.settings.user.isAdmin || vm.settings.user.isManager || (vm.settings.user.isReportViewer && vm.settings.reportViewerSettings.showSkillsReport);
        vm.showDepartmentsReport = vm.settings.user.isAdmin || vm.settings.user.isManager || (vm.settings.user.isReportViewer && vm.settings.reportViewerSettings.showDepartmentsReport);
    }
    
})();